export default __webpack_public_path__ + "static/media/Header.b40057a1.svg";